import { WellRequestStatus_Options } from "./status-enum.model";

export class PendingRequest {
  wellRequestId: bigint | undefined;
  statusToUpdate: WellRequestStatus_Options | undefined;
  comments: string | undefined;
}
